// extracted by mini-css-extract-plugin
export default {"container":"span_container__UBMgX","animatedChar":"span_animatedChar__+VEmp","pulse":"span_pulse__Jtsf0"};